/* eslint-disable react/no-unknown-property */
import React, { useEffect } from 'react';

import Popover from '@material-ui/core/Popover';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga4';

import { isNil } from 'helpers/ramda';

import iconstyle from './index.module.scss';

const PopoverWithCustomIcon = ({
  getTooltipStatus,
  iconComponent,
  hoveredIconComponent,
  popoverComponent,
  transformOrigin,
  anchorOrigin,
  styles,
  parentDivStyle,
  trackEvent,
  iconClassName,
  dataTestId,
  isTopLevelContainer = true,
  onPopOverClose,
  isPopOverCloseTriggered = false,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const containerRef = React.useRef();

  const handleClick = event => {
    if (typeof getTooltipStatus === 'function') {
      getTooltipStatus(true);
    }
    if (trackEvent) {
      ReactGA.event({
        category: 'User',
        action: 'fee_offer',
      });
    }

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    if (typeof getTooltipStatus === 'function') {
      getTooltipStatus(false);
    }
    setAnchorEl(null);
    onPopOverClose?.();
  };

  useEffect(() => {
    if (isPopOverCloseTriggered) {
      setAnchorEl(null);
    }
  }, [isPopOverCloseTriggered]);

  const open = Boolean(anchorEl);

  const iconStyle = open ? iconstyle.active : '';

  return (
    <div style={parentDivStyle} ref={containerRef}>
      {isNil(hoveredIconComponent) ? (
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          data-testid={dataTestId || 'simple-popover'}
          aria-describedby="simple-popover"
          variant="contained"
          onClick={handleClick}
          className={`${iconstyle.icon} ${iconStyle} ${
            open && iconClassName ? `${iconClassName}-active` : ''
          }`}
        >
          {iconComponent}
        </div>
      ) : (
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          data-testid={dataTestId || 'simple-popover'}
          aria-describedby="simple-popover"
          variant="contained"
          onClick={handleClick}
        >
          {open ? hoveredIconComponent : iconComponent}
        </div>
      )}

      <Popover
        id="simple-popover"
        open={open}
        container={!isTopLevelContainer && containerRef.current}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            marginBottom: '10px',
          },
        }}
        style={styles}
        data-testid={dataTestId || 'popover-with-custom-icon'}
        className={styles && styles['popover-class']}
      >
        {popoverComponent}
      </Popover>
    </div>
  );
};

PopoverWithCustomIcon.propTypes = {
  iconComponent: PropTypes.element.isRequired,
  hoveredIconComponent: PropTypes.elementType,
  popoverComponent: PropTypes.element.isRequired,
  transformOrigin: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  anchorOrigin: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  styles: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  parentDivStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  trackEvent: PropTypes.bool,
  iconClassName: PropTypes.string,
  dataTestId: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isTopLevelContainer: PropTypes.bool,
  getTooltipStatus: PropTypes.func,
  // To know whether click outisde closed the popup
  onPopOverClose: PropTypes.func,
  // To close popover when something happens at parent component
  isPopOverCloseTriggered: PropTypes.bool,
};

export default PopoverWithCustomIcon;
